import { MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/5531984297314?text=Ol%C3%A1!%20Vim%20pelo%20site%20da%20Solisy%20e%20quero%20saber%20mais%20sobre%20economia%20na%20conta%20de%20luz.";

export const WhatsAppWidget = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-widget"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Falar no WhatsApp"
    >
      <div className="relative">
        {/* Tooltip */}
        <div className="absolute bottom-full right-0 mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          <div className="bg-slate-800 text-white text-sm px-4 py-2 rounded-xl whitespace-nowrap shadow-lg">
            Fale conosco no WhatsApp
            <div className="absolute top-full right-6 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-slate-800" />
          </div>
        </div>

        {/* Button */}
        <div className="w-16 h-16 rounded-full bg-[#25D366] flex items-center justify-center shadow-2xl whatsapp-pulse hover:scale-110 transition-transform duration-200 cursor-pointer">
          <MessageCircle className="w-8 h-8 text-white" fill="white" />
        </div>
      </div>
    </a>
  );
};
